import DonutChart from "../../component/Dashboard/DonutChart";
import { Target } from "lucide-react";

const PositionStatusComponent = ({ dashboardData }) => {
  const positionStatusData = [
    {
      label: "Open",
      value: dashboardData?.position?.active || 0,
      color: "#133F7D",
    },
    {
      label: "Closed",
      value: dashboardData?.position?.closed || 0,
      color: "#12B6BC",
    },
  ];

  return (
    <div className="">
      <DonutChart
        data={positionStatusData}
        title="Position Status"
        totalValue={dashboardData?.position?.total || 0}
        centerLabel="Total Positions"
        icon={<Target style={{ color: "#133F7D" }} />}
        layout="position-status"
      />
    </div>
  );
};

export default PositionStatusComponent;
